import { render, staticRenderFns } from "./ViewPurchaseOrderDialog.vue?vue&type=template&id=97f9a67e"
import script from "./ViewPurchaseOrderDialog.vue?vue&type=script&lang=js"
export * from "./ViewPurchaseOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewPurchaseOrderDialog.vue?vue&type=style&index=0&id=97f9a67e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports